import { render, staticRenderFns } from "./loading-component.vue?vue&type=template&id=a8ddda96"
import script from "./loading-component.vue?vue&type=script&lang=ts"
export * from "./loading-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports